<h2>Plan Share Modal</h2>
<form [formGroup]="PlanForm" (submit)="share_plan()">
<mat-radio-group
  aria-labelledby="example-radio-group-label"
  class="example-radio-group"
  formControlName="plan_type">
  <mat-radio-button class="example-radio-button" *ngFor="let plan of plans" [value]="plan.id">
    {{plan.name}}
  </mat-radio-button>
</mat-radio-group>
<div *ngIf="submitted && f.plan_type.errors" class="invalid-feedback">
    <div *ngIf="f.plan_type.errors.required">Please select plan</div>
</div>

<button type="submit" [disabled]="loading" class="btn btn-primary mt-2" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>Share Plan</button>
<button type="button" (click)="ClosePlanModal()" class="btn btn-default mt-2 marleft">Close</button>
</form>
<div *ngIf="show_copy" class="margintp20">
  <button type="button" class="copy_btn" (click)="copyToClipboard(sharableLink)">Copy link</button>
  <input readonly type="text" [(ngModel)]="copypaymentlink" #sharableLink>
</div>
